module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 15.b7c0ae16.wav";